module.exports = __webpack_public_path__ + "img/icon-twitter.e14194f5.svg";